import { createMuiTheme, Theme } from "@material-ui/core";
// import RobotWoff2 from "fonts/roboto-latin-regular.woff2";
// import RobotBoldWoff2 from "./fonts/roboto-latin-bold.woff2";
import { headerHeightMobile, headerHeight } from "../constants";
import merge from "lodash/merge";

const regularTheme = (theme: Theme) => {
	const newTheme = createMuiTheme({
		palette: {
			primary: {
				main: "#003473",
			},
			secondary: {
				main: "#facd00",
			},
		},
		// typography: {
		// 	fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"]
		// }
	});

	const overrides = {
		overrides: {
			MuiDrawer: {
				paperAnchorLeft: {
					zIndex: 1300,
					marginTop: headerHeight,
					[theme.breakpoints.down("sm")]: {
						marginTop: headerHeightMobile,
					},
				},
				paperAnchorRight: {
					zIndex: 1300,
					marginTop: headerHeight,
					[theme.breakpoints.down("sm")]: {
						marginTop: headerHeightMobile,
					},
				},
			},
			MuiBackdrop: {
				root: {
					backgroundColor: "unset",
				},
			},
			MuiIconButton: {
				colorInherit: {
					color: "#fff",
				},
			},
			MuiTableCell: {
				head: {
					fontWeight: "bold",
					paddingTop: 6,
				},
				body: {
					fontWeight: "unset",
					padding: 14,
				},
				root: {
					fontWeight: "unset",
				},
			},
			MuiTab: {
				selected: {
					backgroundColor: "#F2F5F8",
				},
				root: {
					textTransform: "none",
					[theme.breakpoints.up("md")]: {
						minHeight: 64,
					},
					maxWidth: "unset",
				},
			},
			MuiPaper: {
				rounded: {
					borderRadius: 8,
				},
			},
			MuiCard: {
				root: {
					height: 180,
					margin: 20,
					padding: 8,
					[theme.breakpoints.down("xs")]: {
						height: 120,
						margin: 12,
					},
				},
			},
			MuiTypography: {
				body1: {
					[theme.breakpoints.down("xs")]: {
						lineHeight: "1.4",
						fontSize: ".95rem",
					},
				},
			},
			MuiToolbar: {
				regular: {
					[theme.breakpoints.down("sm")]: {
						maxHeight: 48,
						minHeight: 48,
					},
				},
				gutters: {
					[theme.breakpoints.down("sm")]: {
						padding: 0,
					},
				},
			},
			MuiPickersToolbar: {
				toolbar: {
					[theme.breakpoints.down("sm")]: {
						minHeight: 100,
						padding: theme.spacing(2),
					},
				},
			},
			MuiOutlinedInput: {
				root: {
					borderRadius: 10,
					backgroundColor: "#fff"
				},
			},
			MuiFilledInput: {
				root: {
					borderRadius: 10,
					backgroundColor: "#fff",
					"&.Mui-focused": {
						backgroundColor: "#fff",
						margin: "24"
					}
				},
				input: {
					padding: 8
				}
			}
		},
	};

	return merge({}, newTheme, overrides);
};

export { regularTheme };
